export default __webpack_public_path__ + "static/media/human_palm.efbca5dc.png";